export const PROCESS_CONTENT = [
  {
    title: 'Define',
    description: 'Define and clarify customer requirements.',
    icon: 'search-outline',
  },
  {
    title: 'Design',
    description: 'Conduct user research and design user flow, user interface.',
    icon: 'pencil-outline',
  },
  {
    title: 'Development',
    description: 'Develop the perfect codes for the customer.',
    icon: 'code-slash-outline',
  },
  {
    title: 'Prototype',
    description:
      'Show a clear representation of the actual product and how it will either look or work.',
    icon: 'construct-outline',
  },
  {
    title: 'Testing',
    description: 'Ensure product quality by constant testing and bug fixing.',
    icon: 'bug-outline',
  },
  {
    title: 'Hand over',
    description: 'Deliver the final product to the customer.',
    icon: 'open-outline',
  },
]
